import React from "react";

const TabNavigationItem = ({ navItem, id, active, onHandleTabClick }) => {
  // Set it active prop is true
  const activeClass = active ? "active" : "";

  return (
    <div
      className={`tabs__nav-item ${activeClass}`}
      onClick={() => onHandleTabClick(id)}
    >
      <div className="tabs__nav-text">{navItem}</div>
    </div>
  );
};

export default TabNavigationItem;
